(function ($) {

    $(document).ready(function () {
        
    });

})(jQuery);

function initPopinSearchform(){
    var $ = jQuery;
    $('.js-open-searchform').click(function () {
        $('body').addClass('is-searchform-shown');
        $('body').addClass('is-overlay-visible');
        jQuery("html, body").animate({ scrollTop: 0 }, 200);
        $('.popin-searchform-head input[name="s"]').focus();
    })
    $('.m-popin-searchform .close').click(function () {
        $('body').removeClass('is-searchform-shown')
        $('body').removeClass('is-overlay-visible');
    });

    var searchTimeout, jqxhr, $results = $('.popin-searchform-body .l-container'), search_val;

    $('.m-popin-searchform input[type="text"]').on('keydown', function () {
        var inputVar = $(this);

        window.setTimeout(function () {
            inputVar.parent().attr("data-space", inputVar.val());
        }, 50);
        
        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(function () {
            if (inputVar.val().length > 2 && search_val !== inputVar.val()) {
                $results.fadeOut(250, function() {$results.html('').show();});
                $('body').removeClass('is-searchform-filled');
                if(jqxhr && jqxhr.readyState != 4){
                    jqxhr.abort();
                }
                search_val = inputVar.val();
                jqxhr = $.get(
                    ajaxurl,
                    {
                        action: 'pix_global_search',
                        s: search_val
                    },
                    function (response) {
                        jqxhr = null;
                        $results.html(response);
                        $('body').addClass('is-searchform-filled');
                    }
                );
            } else if (search_val !== inputVar.val()) {
                $results.fadeOut(250, function() {$results.html('').show();});
                $('body').removeClass('is-searchform-filled');
                clearTimeout(searchTimeout);
                if(jqxhr && jqxhr.readyState != 4){
                    jqxhr.abort();
                }
            }
        }, 300);

    }).trigger('keydown');
}